// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { Set } from "immutable"

// @ts-expect-error: Flow to TS migration.
export const keyIn = (...keys) => {
  const keySet = Set(keys)
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (v: any, k: any) => keySet.has(k)
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/array-type, @typescript-eslint/no-explicit-any
export const iGet = (prop: string | Array<string>) => (x: any) =>
  Array.isArray(prop) ? x.getIn(prop) : x.get(prop)
